import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { ImagePreview } from '@app/entities/images/interfaces/image-preview';
import { GalleryItemComponent } from '../gallery-item/gallery-item.component';

@Component({
  selector: 'app-gallery',
  templateUrl: './gallery.component.html',
  styleUrls: ['./gallery.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [GalleryItemComponent],
})
export class GalleryComponent {
  @Input({ required: true })
  galleryItems!: ImagePreview[];

  @Input() columns: number = 4;
}
